import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(accordionAnatomy.keys);

const baseStyle = definePartsStyle({
  // root: {

  // },
  // container: {

  // },
  button: {
    _hover: {
      bg: 'gray.50',
    },
    _dark: {
      _hover: {
        bg: 'gray.900',
      },
    },
  },
  // panel: {

  // },
  // icon: {

  // },
});

const subtle = definePartsStyle({
  // root: {

  // },
  container: {
    border: 'none',
  },
  button: {
    gap: '0.25em',
    justifyContent: 'center',
    textAlign: 'center',
    _hover: {
      bg: 'transparent',
      textDecoration: 'underline',
    },
    _dark: {
      _hover: {
        bg: 'transparent',
      },
    },
  },
  panel: {
    borderTop: '1px',
    pt: 5,
    px: 0,
    pb: 0,
  },
  // icon: {
  //   w: 'auto',
  // },
});

export default defineMultiStyleConfig({
  baseStyle,
  variants: {
    subtle,
  },
});
